// Usado no pedido do tipo PEDI002 (Prestações por Morte) na lista de habilitandos
export const PersonType = {
  Deceased: -99,
  Sender: -98,
  Beneficiary:0
}

export const PersonTypeString = {
  Deceased: "Deceased",
  Sender: "Sender",
  Beneficiary: "Beneficiary"
}
